import { render, staticRenderFns } from "./SinglePacking.vue?vue&type=template&id=e6f2f5f8"
import script from "./SinglePacking.vue?vue&type=script&lang=js"
export * from "./SinglePacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports